import { ErrorHandlerOptions, SentryErrorHandler } from '@sentry/angular'

// Helper function to safely stringify objects
function safeStringify(obj: any): string {
  try {
    return typeof obj === 'object' ? JSON.stringify(obj) : String(obj)
  } catch (e) {
    return '[Non-serializable Object]'
  }
}

export class GlobalErrorHandler extends SentryErrorHandler {
  constructor(config: ErrorHandlerOptions | undefined) {
    const global = window ?? globalThis
    // Hack that should ensure that GlobalErrorHandler works in zoneless.
    global?.addEventListener('error', (event) => {
      const errorMessage = event.message
        ? event.message
        : event.error && typeof event.error === 'object'
          ? safeStringify(event.error)
          : 'Window Error Handler'

      const error = new Error(errorMessage, {
        cause: JSON.stringify(event.error),
      })
      this.handleError(error)
      event?.preventDefault()
      event?.stopPropagation()
    })
    global?.addEventListener('unhandledrejection', (event) => {
      const message = event.reason?.message ?? 'Window Unhandledrejection Handler'
      let safeReason
      try {
        // Attempt to create a safe representation of event.reason
        safeReason = event.reason instanceof Error ? event.reason : JSON.parse(JSON.stringify(event.reason))
      } catch (e) {
        safeReason = { originalReasonProcessingError: String(e) }
      }

      const error = new Error(message, {
        cause: safeReason,
      })
      this.handleError(error)
      event?.preventDefault()
      event?.stopPropagation()
    })
    super(config)
  }
}
